import React, { useEffect, useState } from 'react'
import { useForm, FormProvider } from "react-hook-form"
import { Box, Paper, Divider, Tab, Tabs, Grid, MenuItem, Pagination, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'

import { useSelector } from 'react-redux';
import { getUser } from 'store/authSlice';

// import { formatDate } from 'utils/function'
import { config } from "../../../config.env";



import {
    ApiFindDropdown,
    ApiMyHealthDiseaseRisk,
    ApiMyHealthNCDs,
    ApiMyHealthExamination,
    ApiDashboardAnalyticsV2,
    ApiNCDsResult,
    ApiNCDsDetail,

    ApiResultHistory
    // ApiHistoryDetail

} from 'utils/api/analytics'

import { ApiExportExcel, ApiExportPDF } from 'utils/api/export'
import Avatar from '@mui/material/Avatar'
import SwipeableViews from "react-swipeable-views";

import { ReactComponent as Bag } from 'assets/icons/myhealth/saline_bag.svg'
import { ReactComponent as Wave } from 'assets/icons/myhealth/wave.svg'
import { ReactComponent as Blood } from 'assets/icons/myhealth/blood.svg'
import { ReactComponent as Ldl } from 'assets/icons/myhealth/ldl.svg'

import bag_grren from 'assets/icons/myhealth/saline_bag_green.svg'
import bag_orange from 'assets/icons/myhealth/saline_bag_orange.svg'
import ruler from 'assets/icons/myhealth/ruler.svg'
import graph_bmi from 'assets/icons/myhealth/graph_bmi.svg'
import cvd_risk from 'assets/icons/myhealth/cvd_risk.svg'
import stroke from 'assets/icons/myhealth/stroke.svg'
import ckd from 'assets/icons/myhealth/ckd.svg'

import moment from 'moment';
import Nodata from 'utils/components/nodata';
// import TableCustom from 'utils/components/table-custom'
import TableCustom from 'utils/components/table-custom-v1'


import DialogSubmit from 'utils/components/modal-submit'



const style = {
    green: {
        backgroundColor: '#C8EBEB',
        border: '1px solid #C8EBEB',
        borderRadius: '5px',
        padding: '5px',
        cursor: 'pointer'
    },
    white: {
        backgroundColor: '#FFFFFF',
        border: '1px solid #AEB4DD',
        borderRadius: '5px',
        padding: '5px',
        color: '#478F96',
        cursor: 'pointer'
    },
    root: {
        "& .MuiPaper-root": {
            border: 'none'
        }
    }
}




function Index() {
    const origin = config.ORIGIN
    const document_url = config.DOCUMENT_ENDPOINT

    const [profile, setProfile] = useState('')

    const [findYear, setFindYear] = useState([])
    const [findFileExport, setFindFileExport] = useState([])



    const [diseaseRisk, setDiseaseRisk] = useState([])
    // const [yearNcds, setYearNcds] = useState('')
    const [ncds, setNcds] = useState('')
    const [ncdsAll, setNcdsAll] = useState([])
    const [year, setYear] = useState('')
    const [yearExamination, setYearExamination] = useState(moment(Date.now()).format('YYYY'))
    const [yearNcds, setYearNcds] = useState(moment(Date.now()).format('YYYY'))
    const [fileExport, setFileExport] = useState(null)




    const [typeSubmit, setTypeSubmit] = useState('')
    const [openSubmit, setOpenSubmit] = useState(false)
    const handleOpenSubmit = (status, close) => {
        setOpenSubmit(status)
        if (close) {

            // console.log({ pid: user?.card_id });
            // console.log('fileExport : ', fileExport);

            if (['EXCEL'].includes(fileExport)) {

                let status = handleExportExcel('ex-0001', [
                    {
                        "type": "string",
                        "field": "pid",
                        "start": user?.card_id,
                        "end": user?.card_id,
                    }
                ], `excel-ข้อมูลผลตรวจสุขภาพ`)
                if (status) {
                    // setFilterExport('null')
                    // setFilterDepartment('all')
                    // setFilterHospital('all')
                    // setFilterYear('all')

                }

            } else if (['PDF'].includes(fileExport)) {

                let result = handleExportPDF({ "document_code": "DOC-002", origin: origin }, { pid: user?.card_id })
                if (status) {
                    // setFilterExport('null')
                    // setFilterDepartment('all')
                    // setFilterHospital('all')
                    // setFilterYear('all')

                }
                // console.log("result : ", result);


                // // let url = `https://healthsystem-uat.mod.go.th/report/documents/checkup/?doc_code=EL-11&pid=${user?.card_id}`
                // let url = `${document_url}/documents/checkup/?origin=${origin}&doc_code=EL-11&pid=${user?.card_id}`
                // window.open(url, '_blank');
            }

            setTypeSubmit()
            setFileExport(null)
        }
    }


    const handleExportExcel = async (excel_code, filter, file_name) => {

        let result = await ApiExportExcel({
            "export_code": excel_code,
            "file_name": file_name,
            "filter": filter
        })

        if (result?.status) {

            let { file_url } = result.data

            // Create a hidden anchor element for downloading the file
            const link = document.createElement('a');
            link.href = file_url;
            link.download = ''; // Optional: specify a custom filename
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            return true

        } else {
            return false

        }





    }

    const handleExportPDF = async (param, payload) => {
        let result = await ApiExportPDF(param)
        if (result?.status) {
            let { document_endpoint } = result?.data
            let url = `${document_endpoint}?origin=${origin}&pid=${payload.pid}`
            window.open(url, '_blank');
            return true
        } else {
            return false

        }
    }


    const [rowsPerPage, setRowsPerPage] = useState(25)
    const [page, setPage] = useState(1)





    const [value, setValue] = useState(0)


    const [dataTable, setDataTable] = useState([])

    const [dataDiseaseRisk, setDataDiseaseRisk] = useState(null)


    const [findNCDsRecord, setFindNCDsRecord] = useState(null)
    const [findRecordHistory, setFindRecordHistory] = useState([])

    const [dataSelect, setDataSelect] = useState(null)



    const user = useSelector(getUser);


    const methods = useForm({
        defaultValues: {

            year_ncds: '',
            year_examination: ''
        },
    });


    useEffect(() => {
        fetchData()
    }, [])


    useEffect(() => {
        fetchDataResultHistory()
    }, [yearExamination])


    useEffect(() => {

        fetchDataResultNCDs()
    }, [yearNcds])


    const fetchDataResultNCDs = async () => {
        ApiNCDsDetail({ pid: user?.card_id, year: yearNcds }).then(res => {
            if (res.status) {
                setFindNCDsRecord(res.data)
            } else {
                setFindNCDsRecord(null)
            }
        })
    }


    const fetchDataResultHistory = async () => {
        ApiResultHistory({ pid: user?.card_id, year: yearExamination }).then(res => {
            if (res.status) {
                setFindRecordHistory(res.data)
            } else {
                setFindRecordHistory(null)
            }
        })
    }



    const fetchData = async () => {

        ApiFindDropdown('year').then(res => {
            if (res.status) {
                let i_code = res.data[res.data?.length - 1]['i_code']
                setYearExamination(i_code)
                setYearNcds(i_code)
                setFindYear(res.data)
            } else {
                setFindYear([])
            }
        })

        ApiFindDropdown('file_export', { i_code: "EXCEL,PDF" }).then(res => {
            if (res.status) {
                setFindFileExport(res.data)
            } else {
                setFindFileExport([])
            }
        })

        ApiMyHealthDiseaseRisk({ pid: user?.card_id }).then(res => {
            if (res.status) {
                // setDataDiseaseRisk(res.data.disease_risk)
                setDataDiseaseRisk(res.data.result)
            } else {
                setDataDiseaseRisk(null)
            }

        })
    }

    const handleChange = (type, event) => {
        if (['year_examination'].includes(type)) {
            // methods.setValue('year_examination', event.target.value)
            setYearExamination(event.target.value)
        } else if (['year_ncds'].includes(type)) {
            // methods.setValue('year_ncds', event.target.value)
            setYearNcds(event.target.value)
        } else if (['file_export'].includes(type)) {
            // methods.setValue('year_ncds', event.target.value)
            setFileExport(event.target.value)
        }
    }



    const handlePageChange = (event, page) => {
        setPage(page)
    }



    const handlemore = () => {

    }


    useEffect(() => {

        if (fileExport === 'EXCEL') {
            handleOpenSubmit(true)
            setTypeSubmit('ผลการตรวจสุขภาพประจำปี')
        } else if (fileExport === 'PDF') {
            handleOpenSubmit(true)
            setTypeSubmit('ผลการตรวจสุขภาพประจำปี')
        }

    }, [fileExport])



    function TabPanel({ children, value, index }) {
        return (
            <div role="tabpanel" hidden={value !== index}>
                {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
            </div>
        );
    }

    console.log(diseaseRisk)


    return (
        <Box sx={{
            margin: "4px",
            flex: 1
        }}>

            <FormProvider {...methods}>

                <Paper
                    sx={{
                        p: "10px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                        flex: 1,
                        overflow: "hidden",
                        // height: '80vh'
                        "@media (max-width: 800px)": {
                            p: "5px"
                        }
                    }}
                >

                    <Box sx={{ display: 'grid', gridGap: '10px' }}>

                        <Box
                            sx={{
                                border: '1px solid #478F96',
                                borderRadius: '10px',
                                padding: '20px',
                                overflow: 'auto',
                                "@media (max-width: 800px)": {
                                    padding: '10px',
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    color: '#478F96',
                                    fontWeight: 600,
                                    pb: 2,
                                }}
                            >
                                ความเสี่ยงการเกิดโรค{" "}
                                <span style={{ color: '#9D9B9B' }}>
                                    (จากผลการตรวจล่าสุด)
                                </span>
                            </Box>

                            <Box
                                sx={{
                                    padding: '20px',
                                    // display: 'flex',
                                    gridGap: '20px',
                                    overflow: 'auto',
                                    "@media (max-width: 800px)": {
                                        padding: '10px',
                                        gridGap: '10px',
                                    },
                                }}
                            >
                                {dataDiseaseRisk ?
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            gridGap: '10px'
                                        }}
                                    >
                                        <Box sx={{
                                            border: '1px solid #E8E7E7',
                                            borderRadius: '10px',
                                            backgroundColor: '#FFFFFF',
                                            boxShadow: '2px 2px 5px #E8E7E7',
                                            padding: '10px',
                                            display: 'grid',
                                            gridGap: '10px',
                                            minWidth: '250px',
                                            width: '250px',
                                            height: '180px'
                                        }}
                                        >
                                            <Box sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gridGap: '10px'
                                            }}>
                                                <img src={cvd_risk} style={{ width: '60px', height: '60px' }} />
                                                <Box sx={{
                                                    fontWeight: 600,
                                                    "@media (max-width: 800px)": {
                                                        fontSize: '14px'
                                                    }
                                                }}>โรคหัวใจและหลอดเลือด (CVD risk)</Box>
                                            </Box>
                                            <Box sx={{ fontSize: '25px', fontWeight: 400 }}>{dataDiseaseRisk['p_risk_result']}</Box>
                                            <Box sx={{ fontSize: '14px', fontWeight: 400 }}>คุณมีความเสี่ยง {dataDiseaseRisk['p_risk_level']}</Box>
                                        </Box>

                                        <Box sx={{
                                            border: '1px solid #E8E7E7',
                                            borderRadius: '10px',
                                            backgroundColor: '#FFFFFF',
                                            boxShadow: '2px 2px 5px #E8E7E7',
                                            padding: '10px',
                                            display: 'grid',
                                            gridGap: '10px',
                                            minWidth: '250px',
                                            width: '250px',
                                            height: '180px'
                                        }}
                                        >
                                            <Box sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gridGap: '10px'
                                            }}>
                                                <img src={stroke} style={{ width: '60px', height: '60px' }} />
                                                <Box sx={{
                                                    fontWeight: 600,
                                                    "@media (max-width: 800px)": {
                                                        fontSize: '14px'
                                                    }
                                                }}>โรคหลอดเลือดสมอง (Stroke)</Box>
                                            </Box>
                                            <Box sx={{ fontSize: '20px', fontWeight: 400 }}>{Number(dataDiseaseRisk['p_full_score']).toFixed(2) + '%'}</Box>
                                            <Box sx={{ fontSize: '14px', fontWeight: 400 }}>ความเสี่ยงในอีก 5 ปีข้างหน้า</Box>
                                        </Box>

                                        {/* <Box sx={{
                                            border: '1px solid #E8E7E7',
                                            borderRadius: '10px',
                                            backgroundColor: '#FFFFFF',
                                            boxShadow: '2px 2px 5px #E8E7E7',
                                            padding: '10px',
                                            display: 'grid',
                                            gridGap: '10px',
                                            minWidth: '250px',
                                            width: '250px',
                                            height: '180px'
                                        }}
                                        >
                                            <Box sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gridGap: '10px'
                                            }}>
                                                <img src={ckd} style={{ width: '60px', height: '60px' }} />
                                                <Box sx={{
                                                    fontWeight: 600,
                                                    "@media (max-width: 800px)": {
                                                        fontSize: '14px'
                                                    }
                                                }}>โรคไตเรื้อรัง (CKD)</Box>
                                            </Box>
                                            <Box sx={{ fontSize: '25px', fontWeight: 400 }}>-</Box>
                                        </Box> */}
                                    </Box>
                                    :
                                    <Nodata />}
                            </Box>
                        </Box>

                        <Box sx={{
                            border: '1px solid #478F96',
                            borderRadius: '10px',
                            padding: '20px',
                            overflow: 'auto',
                            "@media (max-width: 800px)": {
                                padding: '10px'
                            }
                        }}>
                            <Box sx={{ color: '#478F96', fontWeight: 600, pb: 2 }}>ผลตรวจ NCDs</Box>

                            <Select
                                size="small"
                                value={yearNcds || "null"}
                                onChange={(e) => { handleChange('year_ncds', e) }}
                                sx={{
                                    backgroundColor: '#C8EBEB',
                                    border: 'none',
                                    '.MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#C8EBEB',
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#C8EBEB',
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#C8EBEB',
                                    },
                                }}
                            >
                                <MenuItem value="null" disabled>
                                    เลือกปี
                                </MenuItem>
                                {findYear.map((i, idx) => (
                                    <MenuItem key={idx} value={i['i_code']}>{i['i_name']}</MenuItem>
                                ))}
                            </Select>

                            <Box sx={{
                                padding: '20px',
                                gridGap: '20px',
                                overflow: 'auto',
                                "@media (max-width: 800px)": {
                                    padding: '10px',
                                    gridGap: '10px',
                                },
                            }}>
                                {findNCDsRecord ?
                                    <Box sx={{
                                        display: 'flex',
                                        gridGap: '20px',
                                        padding: '20px',
                                        "@media (max-width: 800px)": {
                                            gridGap: '10px',
                                            padding: '10px',
                                        }
                                    }}>
                                        <Box sx={{
                                            border: '1px solid #E8E7E7',
                                            borderRadius: '10px',
                                            backgroundColor: '#FFFFFF',
                                            boxShadow: '2px 2px 5px #E8E7E7',
                                            padding: '10px'
                                        }}>
                                            <Box sx={{
                                                display: 'grid',
                                                gridGap: '10px',
                                                minWidth: '180px',
                                                "@media (max-width: 800px)": {
                                                    gridGap: 0
                                                }
                                            }}>
                                                <Box sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gridGap: '10px'
                                                }}>
                                                    <Bag style={{ width: '60px', height: '60px', stroke: findNCDsRecord['fbs_details']['color'] }} />
                                                    <Box sx={{
                                                        fontWeight: 600,
                                                        "@media (max-width: 800px)": {
                                                            fontSize: '14px'
                                                        }
                                                    }}>น้ำตาลในเลือด</Box>
                                                </Box>
                                                <Box sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gridGap: '10px'
                                                }}>
                                                    <Box sx={{ fontWeight: 600, fontSize: '20px' }}>{findNCDsRecord.fbs}</Box>
                                                    <Box sx={{ color: '#818181', fontSize: '14px' }}>mg / dL</Box>
                                                </Box>
                                                <Box sx={{
                                                    backgroundColor: findNCDsRecord['fbs_details']['color'],
                                                    borderRadius: '5px',
                                                    width: '70px',
                                                    textAlign: 'center',
                                                    "@media (max-width: 800px)": {
                                                        fontSize: '12px'
                                                    }
                                                }
                                                }>{findNCDsRecord.fbs_details.group}</Box>
                                                <Box>
                                                    <Wave style={{ stroke: findNCDsRecord['fbs_details']['color'] }} />
                                                </Box>
                                            </Box>
                                        </Box>
                                        <Box sx={{
                                            border: '1px solid #E8E7E7',
                                            borderRadius: '10px',
                                            backgroundColor: '#FFFFFF',
                                            boxShadow: '2px 2px 5px #E8E7E7',
                                            padding: '10px'
                                        }}>
                                            <Box sx={{
                                                display: 'grid',
                                                gridGap: '10px',
                                                minWidth: '180px',
                                                "@media (max-width: 800px)": {
                                                    gridGap: 0
                                                }
                                            }}>
                                                <Box sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gridGap: '10px'
                                                }}>
                                                    <Blood style={{ width: '60px', height: '60px', stroke: findNCDsRecord['bp_details']['color'] }} />
                                                    <Box sx={{
                                                        fontWeight: 600,
                                                        "@media (max-width: 800px)": {
                                                            fontSize: '14px'
                                                        }
                                                    }}>ค่าความดันโลหิต</Box>
                                                </Box>
                                                <Box sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gridGap: '10px'
                                                }}>
                                                    <Box sx={{ fontWeight: 600, fontSize: '20px' }}>{findNCDsRecord.bps}/ {findNCDsRecord.bpd} </Box>
                                                    <Box sx={{ color: '#818181', fontSize: '14px' }}>mmhg</Box>
                                                </Box>
                                                <Box sx={{
                                                    backgroundColor: findNCDsRecord['bp_details']['color'],
                                                    borderRadius: '5px',
                                                    width: '70px',
                                                    textAlign: 'center',
                                                    "@media (max-width: 800px)": {
                                                        fontSize: '12px'
                                                    }
                                                }}>{findNCDsRecord.bp_details.group}
                                                </Box>
                                                <Box>
                                                    <Wave style={{ stroke: findNCDsRecord['bp_details']['color'] }} />
                                                </Box>
                                            </Box>
                                        </Box>
                                        <Box sx={{
                                            border: '1px solid #E8E7E7',
                                            borderRadius: '10px',
                                            backgroundColor: '#FFFFFF',
                                            boxShadow: '2px 2px 5px #E8E7E7',
                                            padding: '10px'
                                        }}>
                                            <Box sx={{
                                                display: 'grid',
                                                gridGap: '10px',
                                                minWidth: '180px',
                                                "@media (max-width: 800px)": {
                                                    gridGap: 0
                                                }
                                            }}>
                                                <Box sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gridGap: '10px'
                                                }}>
                                                    <Ldl style={{ width: '60px', height: '60px', stroke: findNCDsRecord['ldl_details']['color'] }} />
                                                    <Box sx={{
                                                        fontWeight: 600,
                                                        "@media (max-width: 800px)": {
                                                            fontSize: '14px'
                                                        }
                                                    }}>ไขมันในเลือด</Box>
                                                </Box>
                                                <Box sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gridGap: '10px'
                                                }}>
                                                    <Box sx={{ fontWeight: 600, fontSize: '20px' }}>{findNCDsRecord.ldl}</Box>
                                                    <Box sx={{ color: '#818181', fontSize: '14px' }}>mg / dL</Box>
                                                </Box>
                                                <Box sx={{
                                                    backgroundColor: findNCDsRecord['ldl_details']['color'],
                                                    borderRadius: '5px',
                                                    width: '70px',
                                                    textAlign: 'center',
                                                    "@media (max-width: 800px)": {
                                                        fontSize: '12px'
                                                    }
                                                }
                                                }>{findNCDsRecord.ldl_details.group}
                                                </Box>
                                                <Box>
                                                    <Wave style={{ stroke: findNCDsRecord['ldl_details']['color'] }} />
                                                </Box>
                                            </Box>
                                        </Box>
                                        <Box sx={{
                                            display: 'grid',
                                            gridGap: '10px'
                                        }}>
                                            <Box sx={{
                                                borderRadius: '10px',
                                                backgroundColor: '#F8DEBD',
                                                padding: '10px',
                                                display: 'grid',
                                                width: '180px'
                                            }}>
                                                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 2fr' }}>
                                                    <Box></Box>
                                                    <img src={ruler} />
                                                </Box>
                                                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 2fr' }}>
                                                    <Box>ส่วนสูง</Box>
                                                    <Box sx={{ textAlign: 'center' }}>{findNCDsRecord.height} cm</Box>
                                                </Box>
                                            </Box>
                                            <Box sx={{
                                                borderRadius: '10px',
                                                backgroundColor: '#D0FBFF',
                                                padding: '10px',
                                                display: 'grid',
                                                width: '180px'
                                            }}>
                                                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 2fr' }}>
                                                    <Box></Box>
                                                    <img src={ruler} />
                                                </Box>
                                                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 2fr' }}>
                                                    <Box>น้ำหนัก</Box>
                                                    <Box sx={{ textAlign: 'center' }}>{findNCDsRecord.weight} kg</Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                        <Box sx={{
                                            backgroundColor: '#4A4949',
                                            borderRadius: '10px',
                                            padding: '10px',
                                            display: 'grid'
                                        }}>
                                            <Box sx={{ color: '#FFFFFF' }}>ค่าดัชนีมวลกาย (BMI)</Box>

                                            <Box sx={{
                                                color: '#FFFFFF',
                                                fontSize: '20px',
                                                fontWeight: 600
                                            }}>{findNCDsRecord.bmi}</Box>
                                            <Box>
                                                <Box sx={{
                                                    color: '#FFFFFF',
                                                    "@media (max-width: 800px)": {
                                                        fontSize: '12px'
                                                    }
                                                }}>{'(' + findNCDsRecord.bmi_details.group + ')'}</Box>
                                            </Box>
                                            <Box>
                                                <img src={graph_bmi} />
                                            </Box>
                                        </Box>
                                    </Box> : <Nodata />}

                            </Box>
                        </Box>

                        <Box sx={{
                            border: '1px solid #478F96',
                            borderRadius: '10px',
                            padding: '20px',
                            overflow: 'auto',
                            "@media (max-width: 800px)": {
                                padding: '10px'
                            },
                            //  display: 'flex'
                            // height:'60vh'
                        }}>


                            <Box sx={{ display: 'flex', pb: 5, justifyContent: 'flex-end' }}>
                                <Select
                                    size="small"
                                    value={fileExport || "null"}
                                    onChange={(e) => { handleChange('file_export', e) }}
                                    sx={{
                                        backgroundColor: '#C8EBEB',
                                        border: 'none',
                                        '.MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#C8EBEB',
                                        },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#C8EBEB',
                                        },
                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#C8EBEB',
                                        },
                                    }}
                                >
                                    <MenuItem value="null" disabled>
                                        Export data
                                    </MenuItem>
                                    {findFileExport.map((i, idx) => (
                                        <MenuItem key={idx} value={i['i_code']}>{i['i_name']}</MenuItem>
                                    ))}
                                </Select>
                            </Box>




                            <Grid item xs={12} md={12}>
                                <Box
                                    sx={{
                                        // height: '450px',
                                        border: '1px solid #478F96',
                                        borderRadius: '10px',
                                        // display: 'flex',
                                        justifyContent: 'center', // Center content horizontally
                                        alignItems: 'center',    // Center content vertically
                                        // pt: 5,
                                        // pb: 5,
                                        // pt: 5,
                                        // pl: 5
                                    }}
                                >



                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            width: '100%',
                                            padding: '0 5px',
                                            height: "400px"
                                        }}
                                    >
                                        <Tabs
                                            variant="scrollable"
                                            allowScrollButtonsMobile
                                            value={value}
                                            onChange={(event, newValue) => setValue(newValue)}
                                        // sx={{ p: "0px 5px" }}
                                        >
                                            {findRecordHistory?.data_list && findRecordHistory?.data_list?.length > 0 ? findRecordHistory?.data_list.map(d => {
                                                return (
                                                    <Tab label={d.checklist_group_name}
                                                        sx={{
                                                            fontWeight: 'bold',
                                                            // backgroundColor: (theme) => theme.palette.primary.main,
                                                            color: '#478F96',
                                                            '&.Mui-selected': {
                                                                backgroundColor: '#A3D5D5', // Change color when selected
                                                                color: '#006D6D', // Change text color when selected
                                                            },
                                                        }}
                                                    />
                                                )
                                            }
                                            ) : null}
                                        </Tabs>
                                        <Divider />
                                        <SwipeableViews
                                            index={value}
                                            onChangeIndex={(index) => setValue(index)}
                                        >

                                            {findRecordHistory?.data_list && findRecordHistory?.data_list?.length > 0 ? findRecordHistory?.data_list.map((d, index) => {

                                                let config_head = []
                                                let config_body = []
                                                if (d.checklist_group_code === 'CK-01') {
                                                    let configHead = [
                                                        { name: "ปีที่ตรวจ", minWidth: "90px", align: 'center' },
                                                        { name: "รอบ", align: 'center' }
                                                    ]
                                                    let configBody = [
                                                        { name: 'year', align: 'center', field: 'year' },
                                                        { name: 'inspection_round', align: 'center' }
                                                    ]
                                                    d?.checklist && d?.checklist.forEach(element => {
                                                        configHead.push({ name: element.field_name, minWidth: "130px", align: 'center' })
                                                        configBody.push({ name: element.field, align: 'center' })
                                                    });
                                                    config_head = configHead
                                                    config_body = configBody
                                                } else if (d.checklist_group_code === 'CK-02') {
                                                    let configHead = [
                                                        { name: "ปีที่ตรวจ", minWidth: "90px", align: 'center' },
                                                        { name: "รอบ", align: 'center' }
                                                    ]
                                                    let configBody = [
                                                        { name: 'year', align: 'center', field: 'year' },
                                                        { name: 'inspection_round', align: 'center' }
                                                    ]
                                                    d?.checklist && d?.checklist.forEach(element => {
                                                        configHead.push({ name: element.field_name, minWidth: "180px", align: 'center' })
                                                        configBody.push({ name: element.field, align: 'center' })
                                                    });
                                                    config_head = configHead
                                                    config_body = configBody
                                                } else if (d.checklist_group_code === 'CK-03') {
                                                    let configHead = [
                                                        { name: "ปีที่ตรวจ", minWidth: "90px", align: 'center' },
                                                        { name: "รอบ", align: 'center' }
                                                    ]
                                                    let configBody = [
                                                        { name: 'year', align: 'center', field: 'year' },
                                                        { name: 'inspection_round', align: 'center' }
                                                    ]
                                                    d?.checklist && d?.checklist.forEach(element => {
                                                        configHead.push({ name: element.field_name, minWidth: "180px", align: 'center' })
                                                        configBody.push({ name: element.field, align: 'center' })
                                                    });
                                                    config_head = configHead
                                                    config_body = configBody
                                                } else if (d.checklist_group_code === 'CK-04') {
                                                    let configHead = [
                                                        { name: "ปีที่ตรวจ", minWidth: "90px", align: 'center' },
                                                        { name: "รอบ", align: 'center' }
                                                    ]
                                                    let configBody = [
                                                        { name: 'year', align: 'center', field: 'year' },
                                                        { name: 'inspection_round', align: 'center' }
                                                    ]
                                                    d?.checklist && d?.checklist.forEach(element => {
                                                        configHead.push({ name: element.field_name, minWidth: "180px", align: 'center' })
                                                        configBody.push({ name: element.field, align: 'center' })
                                                    });
                                                    config_head = configHead
                                                    config_body = configBody
                                                } else if (d.checklist_group_code === 'CK-05') {
                                                    let configHead = [
                                                        { name: "ปีที่ตรวจ", minWidth: "90px", align: 'center' },
                                                        { name: "รอบ", align: 'center' }
                                                    ]
                                                    let configBody = [
                                                        { name: 'year', align: 'center', field: 'year' },
                                                        { name: 'inspection_round', align: 'center' }
                                                    ]
                                                    d?.checklist && d?.checklist.forEach(element => {
                                                        configHead.push({ name: element.field_name, minWidth: "180px", align: 'center' })
                                                        configBody.push({ name: element.field, align: 'center' })
                                                    });
                                                    config_head = configHead
                                                    config_body = configBody
                                                }


                                                return (
                                                    <TabPanel value={value} index={index}>
                                                        {d?.data_list && d?.data_list?.length > 0 ? <TableCustom
                                                            data={{ data: d?.data_list }}
                                                            // onSelected
                                                            // selected={select}
                                                            // setSelected={handleSelect}
                                                            // handlemore
                                                            // more={true}
                                                            // listMore={['VIEW', 'EDIT']}
                                                            // handlemore={handlemore}
                                                            // page={page}
                                                            // setPage={setPage}
                                                            // rowsPerPage={rowsPerPage}
                                                            // setRowsPerPage={setRowsPerPage}
                                                            pagination={false}
                                                            sx={{ height: "100%" }}
                                                            head={config_head}
                                                            body={config_body}
                                                        /> : null}
                                                    </TabPanel>
                                                )
                                            }
                                            ) : <Nodata />}


                                        </SwipeableViews>
                                    </Box>



                                </Box>
                            </Grid>





                        </Box>
                    </Box>



                </Paper>


                <DialogSubmit

                    // loading={loading}
                    title={`${typeSubmit}`}
                    fileType={fileExport}
                    // type={alertType}
                    // message={messageAlert}
                    open={openSubmit}
                    setOpen={setOpenSubmit}
                    handleOpenSubmit={handleOpenSubmit}
                // handleChange={handleAlert}



                />

            </FormProvider>




        </Box>

    )
}

export default Index
